import { motion, useScroll, useTransform } from "framer-motion";
import { useLocation } from "react-router-dom";

export const Backdrop = () => {
  const { scrollY } = useScroll();
  const { pathname } = useLocation();
  const y = useTransform(scrollY, [0, 1200], [0, 140]);
  const scale = useTransform(scrollY, [0, 1200], [1.08, 1.18]);
  const dim = useTransform(scrollY, [0, 700], [pathname === "/" ? 0.15 : 0.55, 0.78]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden" aria-hidden="true" data-testid="spooky-backdrop">
      <motion.img
        src="/img/hero.jpg"
        alt=""
        style={{ y, scale }}
        className="absolute inset-0 h-full w-full object-cover object-[65%_center]"
      />
      <div className="moon-glow absolute left-[30%] top-[14%] h-[38vmin] w-[38vmin] rounded-full bg-[radial-gradient(circle,rgba(168,218,220,0.22),transparent_65%)] md:left-[5%] md:top-[6%]" />
      <motion.div style={{ opacity: dim }} className="absolute inset-0 bg-[#07080B]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#07080B]/90 via-[#07080B]/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#07080B] to-transparent" />
      <div className="mist mist-a bottom-[2%] h-[38vh]" />
      <div className="mist mist-b bottom-[-6%] h-[30vh]" />
      <div className="absolute inset-0 shadow-[inset_0_0_220px_rgba(0,0,0,0.9)]" />
    </div>
  );
};
